import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M41.7702 65H36.0046L46.5021 35.1818H53.1705L63.6825 65H57.9169L49.9528 41.2969H49.7198L41.7702 65ZM41.9595 53.3086H57.6839V57.6474H41.9595V53.3086Z"
          fill="currentColor"
          transform="translate(-11.000000, -7.000000)"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
